import React from 'react';
import { IndexRedirect, Redirect, Route, IndexRoute } from 'react-router';
import {default as Config} from './config';

import LoginLayout from './layouts/LoginLayout';
import PageLayout from './layouts/PageLayout';
import CoreLayout from './layouts/CoreLayout';
//login
import Login from './views/LoginView';
import Register from './views/RegisterView';
import ConfirmRegister from './views/ConfirmView';
/** COMPONENTS **/
//customer
import CustomerUpdate from './views/customer/Update';
import CustomerInvoice from './views/customer/Invoice';
import CustomerOrder from './views/customer/Order';
import CustomerOrderCreate from './views/customer/order/Create';
import CustomerOrderUpdate from './views/customer/order/Update';
import CustomerOrderView from './views/customer/order/View';
//sample hardening
import SampleHardeningList from './views/sample_hardening/List';

export default (
	<div>
	<Route name="Strona główna" path={Config.baseUrl+'login'} component={LoginLayout}>
		<IndexRoute component={Login} />
	</Route>
	<Route name="Rejestracja" path={Config.baseUrl+'register'} component={PageLayout}>
		<IndexRoute component={Register} />
		<Route name="Potwierdzenie rejestracji" path='confirm' component={ConfirmRegister} />
	</Route>
	<Route name="Strona główna" path={Config.baseUrl} component={CoreLayout}>
		<Route name="Dane firmy" path='customer'>
			<Route name="Edycja danych firmy" path='update' component={CustomerUpdate} />
			<Route name="Lista faktur" path='invoice' component={CustomerInvoice} />
			<Route name="Lista zleceń" path='order' component={CustomerOrder} />
			<Route name="Dodawanie zlecenia" path='order/create' component={CustomerOrderCreate} />
			<Route name="Edycja zlecenia" path='order/update' component={CustomerOrderUpdate} />
			<Route name="Widok zlecenia" path='order/view' component={CustomerOrderView} />
		</Route>
		<Route name="Próbki hartu" path='sample_hardening' component={SampleHardeningList} />
	</Route>
	</div>
)



/** WEBPACK FOOTER **
 ** ./js/routes.js
 **/